module.exports = __webpack_public_path__ + "static/img/bg-pt.3df3c505.png";